var Gradient;

(function (Gradient) {
  Gradient["shimmer"] = "linear-gradient(85.02deg, #EEEEF1 5.37%, #FBFAFB 47.91%, #EEEEF1 94.15%)";
  Gradient["horizon"] = "linear-gradient(107.34deg, #E65700 0%, #EB7100 51.33%)";
  Gradient["ultraviolet"] = "linear-gradient(108deg, #432E96 0%, #6041D9 53.41%)";
  Gradient["morning"] = "linear-gradient(108deg, #EAA50A 0%, #F2C71B 51.85%)";
  Gradient["spearmint"] = "linear-gradient(108deg, #2DAF83 0%, #39E4AA 52.37%, #39E4AA 52.38%)";
  Gradient["deepsea"] = "linear-gradient(107.34deg, #01508E 0%, #0173CE 52.89%)";
  Gradient["lava"] = "linear-gradient(108deg, #7D142B 0%, #B31B3D 50.28%)";
  Gradient["plum"] = "linear-gradient(108deg, #713880 0%, #A551BC 50.28%)";
})(Gradient || (Gradient = {}));

export default Gradient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/gradient/index.js
// module id = 2032
// module chunks = 12